import Reveal from "./Reveal";

const TUBES_IMG = "https://images.unsplash.com/photo-1748263582756-082fe4adaa5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwcmVzZWFyY2glMjB2aWFsJTIwbGFib3JhdG9yeSUyMGxpcXVpZCUyMGFuYWx5dGljYWwlMjBzY2llbmNlfGVufDB8fHx8MTc5MTcwNzcwOHww&ixlib=rb-4.1.0&q=85";
const SCIENTISTS_IMG = "https://images.unsplash.com/photo-1758685848561-3658f433e6a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwcmVzZWFyY2glMjB2aWFsJTIwbGFib3JhdG9yeSUyMGxpcXVpZCUyMGFuYWx5dGljYWwlMjBzY2llbmNlfGVufDB8fHx8MTc5MTcwNzcwOHww&ixlib=rb-4.1.0&q=85";

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-6">
                    <Reveal>
                        <div className="font-jbm text-xs uppercase tracking-[0.25em] text-cyan-700 mb-3">03 — About AusResearch</div>
                        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900">
                            Built for the bench, not the storefront
                        </h2>
                        <p className="mt-6 text-base leading-relaxed text-slate-600">
                            AusResearch is an Australian research-supply house serving universities, hospital research
                            institutes and private R&D laboratories. We hold no retail storefront and no consumer
                            checkout — supply is arranged exclusively through verified institutional enquiries.
                        </p>
                        <p className="mt-4 text-base leading-relaxed text-slate-600">
                            Our catalog focuses on peptide reference standards across metabolic, growth-hormone-axis,
                            tissue-repair, longevity and neuro research, each documented with batch-specific
                            Certificates of Analysis and shipped under validated cold chain anywhere in Australia.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <div className="mt-10 grid grid-cols-3 gap-6">
                            {[
                                { v: "100%", l: "Batch documented" },
                                { v: "Aus", l: "Wide cold-chain delivery" },
                                { v: "48h", l: "Enquiry response" },
                            ].map((s) => (
                                <div key={s.l} className="border-l-2 border-cyan-700 pl-4">
                                    <div className="font-display text-xl sm:text-2xl font-bold text-slate-900">{s.v}</div>
                                    <div className="font-jbm text-[10px] uppercase tracking-widest text-slate-500 mt-1">{s.l}</div>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                </div>

                <div className="lg:col-span-6 grid grid-cols-2 gap-5">
                    <Reveal delay={0.1} className="mt-10">
                        <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-[0_30px_60px_-24px_rgba(15,23,42,0.25)] group">
                            <img src={TUBES_IMG} alt="Research vials in laboratory rack" className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105" />
                        </div>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-[0_30px_60px_-24px_rgba(15,23,42,0.25)] group">
                            <img src={SCIENTISTS_IMG} alt="Scientists conducting laboratory research" className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105" />
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
